import { styled } from "@mui/styles";
import { LoadingButton as MuiLoadingButton } from "@mui/lab";

export const LoadingButton = styled(MuiLoadingButton)((theme) => ({
  "&.MuiLoadingButton-root": {
    border: "1px solid currentColor",
    color: "inherit"
  }
})) as typeof MuiLoadingButton;